<template>

<div class="col-lg-12 mb-5">
   <div class="d-block no-gutters pl-0"><!--col-lg-10 offset-lg-1-->
        <div v-bind:class="{ 'alertMsg-success': alertType == 'success','alertMsg-info': alertType == 'info','alertMsg-warning': alertType == 'warning' }"> 
            <p v-html="message"></p>
            <!--<button class="btn btn-small btn-brand" v-on:click="hideAlert()">Close</button>-->
        </div>
   </div>
</div>
</template>

<script>
   export default {
      name: 'AlertMessage',
      props: ['message','alertType'],
      data () {
         return {

         }
      },
      methods: {
         hideAlert() {
            this.$emit('hideAlert');
         }
      },
      watch: {
            message(newValue) {
            // Close after 5 seconds
            if (newValue) {
                //alert('redirect: ' + this.RedirectTo);
                //console.log('redirect: ' + this.RedirectTo);
                setTimeout(this.hideAlert, 5000);
            }
            }
        }
   }
</script>